import { TIME_FORMAT_24H } from './constants';

export const formatTimeRange = (start: moment.Moment, end: moment.Moment): string =>
  `${start.format(TIME_FORMAT_24H)} - ${end.format(TIME_FORMAT_24H)}`;
